import React from 'react';
import { FadeIn } from './FadeIn';
export function TomosSection() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1',
    desc: 'Introducción al Derecho · Fuentes · Pirámide de Kelsen · Sistema jurídico argentino'
  }, {
    icon: '📗',
    title: 'Tomo 2',
    desc: 'Derecho Civil Parte General · Persona · Capacidad · Acto Jurídico · Nulidades'
  }, {
    icon: '📙',
    title: 'Tomo 3',
    desc: 'Derechos Humanos y Derecho Constitucional · CN · Garantías · DDHH Internacional'
  }, {
    icon: '📕',
    title: 'Tomo 4',
    desc: 'Historia de las Instituciones Jurídicas · Roma · Independencia · Argentina moderna'
  }, {
    icon: '📓',
    title: 'Tomo 5',
    desc: 'Metodología y Escritura Jurídica · Cómo estudiar derecho · Leer fallos · Redactar'
  }, {
    icon: '📔',
    title: 'Tomo 6',
    desc: 'Oratoria y Preparación de Finales · Método oral · Manejo de nervios · Voz y presencia'
  }];
  return <section className="py-12 px-4 max-w-5xl mx-auto" data-id="element-339">
      <FadeIn data-id="element-340">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-341">
          <span className="text-4xl" data-id="element-342">📚</span> LOS 6 TOMOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-343">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-344">
            <div className="bg-gray-900 border border-gray-800 hover:border-amber-500/50 transition-colors rounded-xl p-6 h-full flex flex-col" data-id="element-345">
              <div className="text-4xl mb-4" data-id="element-346">{tomo.icon}</div>
              <h3 className="text-xl font-bold text-amber-400 mb-2" data-id="element-347">
                {tomo.title}
              </h3>
              <p className="text-gray-300 font-medium leading-relaxed flex-grow" data-id="element-348">
                {tomo.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}